<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">

<!-- Barre haute : retour + compétences, en pleine largeur hors du container -->
<div class="gls-topbar">
  <a class="gls-back" [routerLink]="['/', langSrcSrv.current.shortCode, 'games']">
    <i class="fa-solid fa-arrow-left"></i>
    <span translate>Parcours</span>
  </a>
  <button type="button" class="gls-skills" (click)="skills()">
    <i class="fa-solid fa-star"></i>
    <span translate>Compétences</span>
  </button>
</div>

<div class="gls" [class.gls--mobile]="deviceSrv.isMobile()">

  <!-- Bandeau section : titre + progression -->
  <div class="gls-hero">
    <div class="gls-hero-main">
      <div class="gls-hero-eyebrow">
        <span translate>Parcours</span>
        <span *ngIf="data.totalSections"> · <span translate>Section</span> {{ data.position + 1 }}/{{ data.totalSections }}</span>
      </div>
      <h1 class="gls-hero-title">
        {{ data.section.translation }}
        <span class="gls-cefrl" *ngIf="data.cefrl">{{ data.cefrl }}</span>
      </h1>
      <div class="gls-hero-sub">
        {{ data.levels.length }} <span translate>niveaux</span> · {{ completedCount }} <span translate>terminés</span>
      </div>
    </div>
    <div class="gls-hero-progress">
      <div class="gls-hero-pct"><strong>{{ sectionProgressPercent }}%</strong> <span translate>complété</span></div>
      <div class="gls-hero-track">
        <div class="gls-hero-fill" [style.width.%]="sectionProgressPercent"></div>
      </div>
    </div>
  </div>

  <!-- Légende des pastilles de jeux -->
  <div class="gls-legend">
    <span class="gls-legend-intro"><span translate>Chaque niveau = plusieurs jeux</span> ·</span>
    <span class="gls-legend-item"><i class="gls-dot gls-dot--done"></i><span translate>Jeu réussi</span><span *ngIf="passRatio">&nbsp;(&ge; {{ passRatio }}&nbsp;%)</span></span>
    <span class="gls-legend-item" *ngIf="hasStartedGames"><i class="gls-dot gls-dot--started"></i><span translate>Commencé</span><span *ngIf="passRatio">&nbsp;(&lt; {{ passRatio }}&nbsp;%)</span></span>
    <span class="gls-legend-item"><i class="gls-dot gls-dot--todo"></i><span translate>Non joué</span></span>
  </div>

  <!-- Timeline des niveaux -->
  <ol class="gls-path">

    <li class="gls-item"
        *ngFor="let level of data.levels; let i = index; trackBy: trackByIndex"
        [class.gls-item--current]="level.state === 'current'"
        [style.animationDelay]="(i * 50) + 'ms'">

      <!-- Rail : nœud d'étape + ligne verticale -->
      <div class="gls-rail">
        <div class="gls-node"
             [ngClass]="'gls-node--' + level.state"
             [class.gls-node--perfect]="level.perfect">
          <i class="fa-solid fa-check" *ngIf="level.state === 'completed' || level.state === 'validated'"></i>
          <i class="fa-solid fa-forward" *ngIf="level.state === 'skipped'"></i>
          <i class="fa-solid fa-crown" *ngIf="level.state === 'locked' && isPremiumLocked(level.position + 1)"></i>
          <span *ngIf="level.state === 'current' || level.state === 'unlocked' || (level.state === 'locked' && !isPremiumLocked(level.position + 1))">{{ i + 1 }}</span>
        </div>
        <div class="gls-line" [class.gls-line--done]="railDone(i)"></div>
      </div>

      <!-- Carte niveau -->
      <div class="gls-card"
           [class.gls-card--locked]="level.state === 'locked'"
           [class.gls-card--current]="level.state === 'current'"
           [class.gls-card--premium]="isPremiumLocked(level.position + 1)"
           (click)="navigateToLevel(level, level.position + 1)">

        <div class="gls-premium-chip" *ngIf="isPremiumLocked(level.position + 1)">
          <i class="fa-solid fa-crown"></i>
          <span translate>Premium</span>
        </div>

        <div class="gls-card-head">
          <div class="gls-card-titles">
            <div class="gls-card-name">{{ level.name }}</div>
            <div class="gls-card-meta" *ngIf="level.games?.total">
              {{ level.games.total }} <span translate>jeux</span><ng-container *ngIf="level.state !== 'skipped'"> · {{ level.gamesDone }}/{{ level.games.total }} <span translate>réussis</span></ng-container>
            </div>
          </div>
          <div class="gls-card-status">
            <span class="gls-score"
                  *ngIf="level.bestScore > 0"
                  [class.gls-score--gold]="level.perfect"
                  [class.gls-score--green]="level.state === 'completed' && !level.perfect"
                  [class.gls-score--blue]="level.state === 'current' || level.state === 'unlocked' || level.state === 'validated'">{{ level.bestScore }}%</span>

            <span class="gls-badge gls-badge--perfect" *ngIf="level.perfect">
              <i class="fa-solid fa-star"></i>
              <span translate>Parfait</span>
            </span>
            <span class="gls-badge gls-badge--done" *ngIf="level.state === 'completed' && !level.perfect" translate>Réussi</span>
            <span class="gls-badge gls-badge--validated" *ngIf="level.state === 'validated'" translate>Validé</span>
            <span class="gls-badge gls-badge--current" *ngIf="level.state === 'current' || level.state === 'unlocked'" translate>En cours</span>
            <span class="gls-badge gls-badge--skipped" *ngIf="level.state === 'skipped'" translate>Accès libre</span>
            <span class="gls-badge gls-badge--locked" *ngIf="level.state === 'locked'" translate>Verrouillé</span>
          </div>
        </div>

        <!-- Une pastille par jeu -->
        <div class="gls-chips" *ngIf="level.state !== 'locked' && level.state !== 'skipped' && level.chips?.length">
          <span class="gls-chip"
                *ngFor="let chip of level.chips; trackBy: trackByIndex"
                [ngClass]="'gls-chip--' + chip">
            <i class="fa-solid fa-check" *ngIf="chip === 'done'"></i>
          </span>
        </div>

        <!-- Pied de carte : indication + action -->
        <div class="gls-card-foot" *ngIf="level.state === 'completed'">
          <div class="gls-hint gls-hint--gold" *ngIf="level.perfect">
            <span translate>Niveau maîtrisé — 100 %</span>
          </div>
          <div class="gls-hint gls-hint--valid" *ngIf="!level.perfect && !(level.bestScore > 0)">
            <i class="fa-solid fa-circle-check"></i>
            <span translate>Niveau validé</span>
          </div>
          <div class="gls-hint" *ngIf="!level.perfect && level.bestScore > 0">
            <span translate>Rejouez pour viser le 100 %</span>
          </div>
          <button type="button" class="gls-btn gls-btn--ghost">
            <i class="fa-solid fa-rotate-right"></i>
            <span translate>Rejouer</span>
          </button>
        </div>

        <div class="gls-card-foot" *ngIf="level.state === 'validated'">
          <div class="gls-hint">
            <i class="fa-solid fa-forward"></i>
            <span translate>Validé par ton test de placement — rejoue pour viser le 100 %</span>
          </div>
          <button type="button" class="gls-btn gls-btn--ghost">
            <i class="fa-solid fa-play"></i>
            <span translate>Jouer</span>
          </button>
        </div>

        <div class="gls-card-foot" *ngIf="level.state === 'current' || level.state === 'unlocked'">
          <button type="button" class="gls-btn gls-btn--primary">
            <i class="fa-solid fa-play"></i>
            <span translate>Reprendre</span>
          </button>
        </div>

        <div class="gls-card-foot" *ngIf="level.state === 'skipped'">
          <div class="gls-hint">
            <i class="fa-solid fa-unlock"></i>
            <span translate>Passée par ton test de placement</span>
          </div>
          <button type="button" class="gls-btn gls-btn--ghost">
            <i class="fa-solid fa-play"></i>
            <span translate>Jouer</span>
          </button>
        </div>

        <div class="gls-card-foot" *ngIf="level.state === 'locked' && i === firstLockedIndex && !isPremiumLocked(level.position + 1)">
          <div class="gls-hint">
            <i class="fa-solid fa-lock"></i>
            <span translate>Réussissez tous les jeux du niveau en cours pour déverrouiller</span>
          </div>
        </div>

      </div>
    </li>

    <!-- Étape finale : la prochaine étape du parcours -->
    <li class="gls-item gls-item--end" [style.animationDelay]="(data.levels.length * 50) + 'ms'">
      <div class="gls-rail">
        <div class="gls-node gls-node--end" [class.gls-node--end-done]="endStepHighlighted">
          <i class="fa-solid fa-graduation-cap" *ngIf="data.nextStep?.type === 'exam'"></i>
          <i class="fa-solid fa-flag-checkered" *ngIf="data.nextStep?.type !== 'exam'"></i>
        </div>
      </div>

      <a class="gls-card gls-end"
         [class.gls-end--exam]="data.nextStep?.type === 'exam'"
         [class.gls-end--done]="endStepHighlighted"
         [class.gls-end--disabled]="data.nextStep && !nextStepAccessible"
         [routerLink]="(data.nextStep && !nextStepAccessible) ? null : nextStepLink">

        <ng-container *ngIf="data.nextStep">
          <div class="gls-end-title">
            <span translate>Prochaine étape</span> : {{ data.nextStep.name }}
          </div>
          <div class="gls-end-sub" *ngIf="!nextStepAccessible" translate>Termine tous les niveaux de cette section pour y accéder.</div>
          <div class="gls-end-sub" *ngIf="nextStepAccessible" translate>C'est parti, continue ta route !</div>
        </ng-container>
        <ng-container *ngIf="!data.nextStep">
          <div class="gls-end-title" *ngIf="!sectionDone" translate>La suite du parcours t'attend</div>
          <div class="gls-end-sub" *ngIf="!sectionDone" translate>Termine tous les niveaux de cette section pour continuer ta route.</div>
          <div class="gls-end-title" *ngIf="sectionDone" translate>Section terminée, bravo !</div>
          <div class="gls-end-sub" *ngIf="sectionDone" translate>Retourne sur le parcours pour continuer ta route.</div>
        </ng-container>

      </a>
    </li>

  </ol>

</div>

</ng-container>
